import { Chip, Grid, styled } from "@mui/material";
import BarekamText from "../../../components/text";

export const NewOrderDetailsContainer = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    padding: '1rem',
    gap: '1rem'
}));

export const ExistingOrderDetailsContainer = styled(Grid)(() => ({
    padding: '1rem',

    '& .MuiGrid-root': {
        display: 'flex'
    }
}));

export const BarekamTextContainer = styled('div')(() => ({
    display: 'flex',
    alignItems: 'center'
}));

export const OrderStatusChip = styled(Chip)(({ theme }) => ({
    color: theme.barekam.orderPopup.chips.statusChip.color,
    display: 'flex',
    padding: '0.125rem 0.5rem',
    alignItems: 'center',
    gap: '0.625rem',
    borderRadius: '0.25rem',
    height: 'unset',
    backgroundColor: theme.barekam.orderPopup.chips.statusChip.backgroundColor,
}));